export default class UpdateAsistencia {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idAsistencia, payload) {
    try {
      return await this.#repository.updateAsistencia(idPersonal, idAsistencia, payload)
    } catch (error) {
      console.error('Error al editar la asistencia:', error)
      throw error
    }
  }
}
